/**
 * Sanitizes a beer style name into a valid Firestore document ID.
 * Converts to camelCase: "American Amber Ale" -> "americanAmberAle"
 */
export function sanitizeStyleId(name) {
  if (!name) return '';
  const trimmed = name.trim();
  if (!trimmed) return '';
  return trimmed
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .split(/\s+/)
    .filter((word) => word.length > 0)
    .map((word, index) => {
      if (index === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('');
}
